import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { IdValueObject } from '../../../../utility/model/id-value-object.model';

export class CategoryAnchorId extends IdValueObject {
  static create(value: string): CategoryAnchorId {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new CategoryAnchorId(value);
  }
}
